<div class="wrapper {{class}}" [ngClass]="{'hideEducationMaterials':hideEducationMaterials, 'past-class': isPast}" *transloco="let t; read: 'studentProgress'">

    <div class="color-block w-60" [ngClass]="{'clickable':!hideEducationMaterials  && data.selfStudyUrl}"
         (click)="data.selfStudyUrl ? openUrl(data.selfStudyUrl, true) : null">

        <div class="top-section">
            <div class="title" [ngClass]="{'animation': +data.completed! < 55 && this.animated && !hideEducationMaterials}" >

<!--                <img src="assets/images/icons/flag.svg" alt="flag" class="flag">-->
                <svg class="flag"  width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.354 0.583984C3.59563 0.583984 3.7915 0.77986 3.7915 1.02148V2.10065L4.79523 1.89991C5.75804 1.70734 6.75607 1.79898 7.66771 2.16363L7.7865 2.21115C8.69718 2.57542 9.69949 2.64345 10.651 2.40556C11.0928 2.29513 11.5207 2.62922 11.5207 3.08455V7.38198C11.5207 7.75782 11.2649 8.08543 10.9003 8.17659L10.7752 8.20786C9.74292 8.46592 8.65561 8.39213 7.66771 7.99697C6.75607 7.63231 5.75804 7.54068 4.79523 7.73324L3.7915 7.93399V12.6882C3.7915 12.9298 3.59563 13.1257 3.354 13.1257C3.11238 13.1257 2.9165 12.9298 2.9165 12.6882V1.02148C2.9165 0.77986 3.11238 0.583984 3.354 0.583984Z" fill="#3F403F"/>
                </svg>

<!--                {{ hideEducationMaterials ? t('soon') : isPast ? t('completed') : t('prepared') }}-->
                {{isPast ? t('completed') : hideEducationMaterials ? t('soon') : t('prepared') }}


            </div>

            <div class="next" *ngIf="!hideEducationMaterials && data.selfStudyUrl"
                 (click)="openUrl(data.selfStudyUrl, true)">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="12" fill="#3F403F"/>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M9.67461 6.95437C9.88428 6.77465 10.1999 6.79893 10.3796 7.0086L14.3796 11.6753C14.5401 11.8625 14.5401 12.1388 14.3796 12.3261L10.3796 16.9927C10.1999 17.2024 9.88428 17.2267 9.67461 17.047C9.46495 16.8672 9.44067 16.5516 9.62038 16.3419L13.3415 12.0007L9.62038 7.65939C9.44067 7.44973 9.46495 7.13408 9.67461 6.95437Z"
                          fill="white"/>
                </svg>

            </div>

        </div>

        <div class="white-block">

            <div class="img-wrapper">

                <img
                    src="assets/images/student/{{isPast || hideEducationMaterials ?'book_2_shadow.svg': 'book_2.svg' }}"
                    alt="textbook">

            </div>

            <div class="info">

                <div class="title "> SELF STUDY {{ data.lessonNumber }}</div>

                <div class="done">
                    <span> {{t('done') }}: </span>

                    {{ data.completed }}%
                </div>


                <div class="correct">
                    <span> {{t('correct') }}:</span>

                    {{ data.correct }}%

                </div>

            </div>


        </div>


    </div>


    <div class="color-block w-40" [ngClass]="{'clickable':!hideEducationMaterials  && data.lessonUrl}"
         (click)="data.lessonUrl ? openUrl(data.lessonUrl) : null">

        <div class="top-section">
            <div class="title">

                <img src="assets/images/icons/flag.svg" alt="flag">

<!--                {{ hideEducationMaterials ?  t('soon') : isPast ? t('completed') :  t('atLesson') }}-->
                {{ isPast ? t('completed') : hideEducationMaterials ?  t('soon') :  t('atLesson') }}

            </div>

            <div class="next" *ngIf="!hideEducationMaterials && data.lessonUrl" (click)="openUrl(data.lessonUrl)">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="12" fill="#3F403F"/>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M9.67461 6.95437C9.88428 6.77465 10.1999 6.79893 10.3796 7.0086L14.3796 11.6753C14.5401 11.8625 14.5401 12.1388 14.3796 12.3261L10.3796 16.9927C10.1999 17.2024 9.88428 17.2267 9.67461 17.047C9.46495 16.8672 9.44067 16.5516 9.62038 16.3419L13.3415 12.0007L9.62038 7.65939C9.44067 7.44973 9.46495 7.13408 9.67461 6.95437Z"
                          fill="white"/>
                </svg>

            </div>

        </div>

        <div class="white-block-center">

            <div class="img-wrapper">

                <img
                    src="assets/images/student/{{isPast || hideEducationMaterials ? 'children_shadow.svg' : 'children.svg' }}"
                    alt="lesson">

            </div>

            <div class="title">
                LESSON {{ data.lessonNumber }}
            </div>


        </div>


    </div>


</div>
